layui.define(function (exports) {
    // 兼容pearAdmin写法
    //var $ = layui.jquery, form = layui.form, layer = layui.layer, table = layui.table;
    var api = {
        v: '1.0.5',
        config: {
            imageExts: 'jpg|jpeg|png|peng|gif|bmp',
            fileExts: 'xls|xlsx|doc|docx|pdf|ppt',
            times: 2000,
            hint: 'alert',  //提示类型，alert对话框，msg 提示
            uploadImgUrl: '',    //上传图片地址
            uploadFileUrl: '',    //上传文件地址
            errorInfo: '发生了错误，请截图发给技术支持，谢谢！</br>错误信息：<span class="red">{info}</span>' //错误信息模板
        },
        //设置配置信息
        setConfig: function (opt) {
            this.config = lay.extend({}, this.config, opt);
        },
        //提示信息
        tips: function (title, type, times) {
            title = title || '提示信息';
            times = times || 3000;
            type = type || 1;  //0 成功  1成功  2错误X  3询问  4锁定  5哭泣  6笑脸  7感叹号
            if (api.isString(type)) {
                var opt = {'success': 1, 'error': 2, 'ask': 3, 'lock': 4, 'cry': 5, 'smile': 6, 'warm': 7};
                type = opt[type] || 1;
            }
            layui.layer.msg(title, {icon: type, time: times});
        },
        //警告弹窗
        warm: function (title, callback) {
            layui.layer.alert(title, {icon: 7, skin: 'layer-ext-moon'}, function (index) {
                layer.close(index);
                if (callback) {
                    api.isBack(callback, index);
                }
            });
        },
        //成功弹窗
        success: function (title, callback) {
            layui.layer.alert(title, {icon: 1, skin: 'layer-ext-moon'}, function (index) {
                layui.layer.close(index);
                if (callback) {
                    api.isBack(callback, index);
                }
            });
        },
        //错误弹窗
        error: function (title, callback) {
            layui.layer.alert(api.config.errorInfo.replace('{info}', title), {
                icon: 2,
                skin: 'layer-ext-moon'
            }, function (index) {
                layui.layer.close(index);
                if (callback) {
                    api.isBack(callback, index);
                }
            });
        },
        //网络请求
        ajax: function (url, opt, param, callback) {
            //默认请求参数
            param.deviceType = "pc"; //设备类型
            //配置参数
            opt = lay.extend({}, {
                method: 'post',
                dataType: 'json',
                async: true,
                timeout: 30000,
                headers: {},
                contentType: "application/x-www-form-urlencoded",
                callbackType: 'auto',  //回调类型，auto 自动判断，back 直接返回
                loading: true,  //是否显示加载层
                loadingText: '正在加载中...',
                loadingTime: 3000,
                showResult: true,  //是否显示返回结果
                showResultText: true,
            }, opt);
            
            var loading = null;
            
            //加载层处理
            if (opt['loading']) {
                loading = layer.msg(opt['loadingText'], {icon: 16, shade: 0.2, time: opt['loadingTime']});
            }
            
            layui.$.ajax({
                url: url,
                type: opt['method'],
                data: param,
                dataType: opt['dataType'],
                contentType: opt['contentType'],
                async: opt['async'],
                timeout: opt['timeout'],
                headers: opt['headers'],
                cache: false,
                success: function (res) {
                    //关闭加载层
                    layer.close(loading);
                    // 回调方式
                    if (opt['callbackType'] === 'auto') {
                        //自动处理
                        if (res.status === 'noauth') {
                            //未授权
                            api.error('您没有访问权限');
                        } else if (res.status === 'nologin') {
                            //登录失效
                            api.error('您登录状态已失效');
                        } else if (res.status === 'error') {
                            //错误提示
                            api.error(res.info);
                        } else if (res.status === 'no') {
                            //执行失败
                            api.warm(res.info);
                        } else if (res.status === 'verify') {
                            api.isBack(callback, res, opt);
                        } else if (res.status === 'ok') {
                            //执行成功
                            if (opt.showResult){
                                // 显示返回结果
                                api.tips(res.info);
                            }
                            api.isBack(callback, res, opt);
                        } else {
                            api.isBack(callback, res, opt);
                        }
                    } else {
                        //直接返回
                        api.isBack(callback, res, opt);
                    }
                },
                error: function (res) {
                    layer.close(loading);
                    if (opt['callbackType'] === 'auto') {
                        api.error('网络连接错误，请稍后再试');
                    } else {
                        if (res.responseJSON){
                            api.isBack(callback, res.responseJSON, opt);
                        }else{
                            api.isBack(callback, res, opt);
                        }
                    }
                }
            })
        },
        //判断是否为函数
        isFunction: function (obj) {
            return this.isTargetType(obj, "function");
        },
        //判断是否为字符串
        isString: function (str) {
            return this.isTargetType(str, "string");
        },
        //判断是否为指定类型
        isTargetType: function (obj, typeString) {
            return typeof obj === typeString;
        },
        //判断是否为数组
        isArray: function (arr) {
            return Array.isArray(arr);
        },
        //判断是否为数字
        isNumber: function (num) {
            return !isNaN(num);
        },
        //随机字符串生成
        randomStr(type, len) {
            var characters = '';
            var result = '';
            len = len || 16;
            if (type === 'number') {
                //数字类型
                characters = '0123456789';
            } else if (type === 'char') {
                //字符类型
                characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            } else {
                //混合类型
                characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            }
            
            for (var i = 0; i < len; i++) {
                var randomIndex = Math.floor(Math.random() * characters.length);
                result += characters.charAt(randomIndex);
            }
            return result;
        },
        //回调函数处理
        isBack: function (obj, ret, opt) {
            // 回调函数不存在时，直接返回false
            if (obj === undefined) {
                //如果需要展示效果，这里需要提示下
                if (opt && opt.showResult) {
                    api.tips(ret.info,1);
                }
                return false;
            }
            
            ret = ret || "";
            if (this.isFunction(obj)) {
                obj(ret,opt);
            } else {
                switch (obj) {
                    case 1:
                        //刷新当前页面
                        location.reload();
                        break;
                    case 2:
                        //刷新当前页面
                        setTimeout("location.reload();", api.config.times);
                        break;
                    case 3:
                        //刷新当前表格
                        layui.table.reload('dataTable');
                        break;
                    case 4:
                        //刷新当前表格
                        setTimeout("layui.table.reload('dataTable');", api.config.times);
                        break;
                    case 5:
                        //刷新当前表格
                        layui.table.reload('dataTable');
                        layui.layer.closeAll();
                        break;
                    case 6:
                        //刷新当前表格
                        setTimeout("layui.table.reload('dataTable');layui.layer.closeAll();", api.config.times);
                        break;
                    case 7:
                        //刷新父页面表格
                        parent.layui.table.reload('dataTable');
                        break;
                    case 8:
                        //刷新父页面表格
                        setTimeout("parent.layui.table.reload('dataTable');", api.config.times);
                        break;
                    case 9:
                        //刷新父页面表格
                        parent.layui.table.reload('dataTable');
                        parent.layui.layer.closeAll();
                        break;
                    case 10:
                        //刷新父页面表格
                        setTimeout("parent.layui.table.reload('dataTable');parent.layui.layer.closeAll();", api.config.times);
                        break;
                    case 11:
                        //刷新父页面
                        parent.layui.location.reload();
                        break;
                    case 12:
                        //延时刷新父页面
                        setTimeout("parent.layui.location.reload();", api.config.times);
                        break;
                    default:
                        setTimeout(obj, api.config.times);
                        break;
                }
            }
        },
        // 搜索
        search: function (opt) {
            //公共搜索按钮
            opt['table'] = opt['table'] || 'dataTable';
            opt['page'] = {curr: 1};
            layui.table.reload(opt['table'], opt, true);
        },
        // 刷新
        refresh: function () {
            location.reload();
        },
        // 当前页面工具
        tools: function (opt, callback) {
            opt['deleteText'] = opt['deleteText'] || '删除';
            opt['recoveryText'] = opt['recoveryText'] || '恢复';
            layui.form.on('submit()', function (data) {
                if (data.filter === undefined) {
                    //空按钮，不处理
                } else if (data.filter === 'search') {
                    //监听搜索按钮
                    api.search({where: data.field});
                } else if (data.filter === 'export') {
                    //监听导出按钮
                    api.export(opt['down'], data.field);
                } else if (data.filter === 'refresh') {
                    //监听刷新按钮
                    api.refresh();
                } else if (data.filter === 'go') {
                    //监听跳转按钮
                    location.href = $(this).data("href");
                } else if (data.filter === 'tab') {
                    //监听新增tab按钮
                    var tabId= $(this).data("tabid");
                    var tabName = $(this).data("tabName");
                    var tabLink = $(this).data("tabLink");
                    parent.layui.admin.addTab(tabId, tabName, tabLink);
                } else {
                    callback(data.filter, {});
                }
            })
            
            //监听下拉框选择项
            layui.form.on('select()', function (data) {
                if (data.filter !== undefined) {
                    var param = {};
                    param[data.filter] = data.value;
                    api.search({where: param});
                }
            });
            
            //监听排序
            table.on('sort(dataTable)', function (obj) {
                if (obj.type == null) {
                    api.search({initSort: obj, where: {sort: null}});
                } else {
                    api.search({initSort: obj, where: {sort: obj.field + ' ' + obj.type}});
                }
            })
            
            //监听表格后面工具条
            table.on('tool(dataTable)', function (obj) {
                var data = obj.data, layEvent = obj.event;
                if (!(Reflect.has(opt, layEvent)) && layEvent !=='tab' && layEvent !=='go') {
                    //没有或者自定义配置不齐全
                    if (api.isFunction(callback)) {
                        callback(layEvent, data);
                    } else {
                        api.error("当前未检测事件[" + layEvent + "]的配置");
                    }
                } else {
                    if (layEvent === 'add') {
                        location.href = opt.add;
                    } else if (layEvent === 'view') {
                        api.dataView(opt.view + "?id=" + data['id'], {title: opt.name + "“" + data[opt.field] + "” 查看", winWidth: opt.winWidth, winHeight: opt.winHeight});
                    } else if (layEvent === 'edit') {
                        api.dataView(opt.edit + "?id=" + data['id'], {title: opt.name + "“" + data[opt.field] + "” 编辑", winWidth: opt.winWidth, winHeight: opt.winHeight});
                    } else if (layEvent === 'frozen') {
                        api.dataPrompt(opt.frozen, {msg: "您确定冻结该" + opt.name, param: 'remark', placeholder: '请输入冻结的原因'}, {id: data['id']}, 3);
                    } else if (layEvent === 'unfrozen') {
                        api.dataPrompt(opt.unfrozen, {msg: "您确定解冻该" + opt.name, param: 'remark', placeholder: '请输入解冻的原因'}, {id: data['id']}, 3);
                    } else if (layEvent === 'delete') {
                        api.dataDelete(opt.delete, {msg: '您确定要永久' + opt['deleteText'] + ' “' + data[opt.field] + '” 的' + opt.name + '吗？'}, {id: data['id']}, 4);
                    } else if (layEvent === 'destroy') {
                        api.dataDelete(opt.destroy, {msg: '您确定要' + opt['deleteText'] + ' “' + data[opt.field] + '” 的' + opt.name + '吗？'}, {id: data['id']}, 4);
                    } else if (layEvent === "recovery") {
                        api.dataRecovery(opt.recovery, {msg: '您确定要' + opt['recoveryText'] + ' “' + data[opt.field] + '” 的' + opt.name + '吗？'}, {id: data['id']}, 4);
                    } else if (layEvent === "pass") {
                        api.dataEdit(opt.pass, {msg: '您确定要通过 “' + data[opt.field] + '” 的' + opt.name + '吗？'}, {id: data['id']}, 4);
                    } else if (layEvent === "reject") {
                        api.dataPrompt(opt.reject, {msg: '您确定要拒绝 “' + data[opt.field] + '” 的' + opt.name + '吗？', placeholder: '请输入拒绝理由', param: 'remark'}, {id: data['id']}, 4);
                    } else if (layEvent === 'tab') {
                        //监听新增tab按钮
                        var tabId= $(this).data("tabid");
                        var tabName = $(this).data("tabName");
                        var tabLink = $(this).data("tabLink");
                        parent.layui.admin.addTab(tabId, tabName, tabLink);
                    }else if (layEvent === 'go') {
                        //监听跳转按钮
                        location.href = $(this).data("href");
                    } else {
                        api.error("当前未检测到按钮类型2");
                    }
                }
            });
            
            //监听头部工具按钮
            table.on('toolbar(dataTable)', function (obj) {
                var checkStatus = table.checkStatus(obj.config.id);
                var layEvent = obj.event;
                if (api.isFunction(callback)) {
                    callback(layEvent, checkStatus);
                } else {
                    api.error("当前未检测事件[" + layEvent + "]的配置");
                }
            });
            
            //监听单元格编辑
            table.on('edit(dataTable)', function (obj) {
                var value = obj.value, data = obj.data, field = obj.field;
                if (opt['editfield'] === undefined) {
                    api.error("当前未检测到编辑字段的URL配置");
                    return false;
                }
                
                api.changeValue(opt['editfield'], {}, {id: data.id, field: field, value: value});
            });
        },
        //加载下来的option
        loadOptions: function (obj, opt, param, callback) {
            //合并配置
            opt = lay.extend({}, {all: true, index: 'id', text: 'name', placeholder: '请选择', empty: '暂无数据',showResult:false}, opt);
            param = lay.extend({}, param || {});
            //判断elem是否存在
            if (opt.elem === undefined) {
                api.error("elem属性不得为空");
                return false;
            }
            
            //判断obj是网址还是数组
            if (api.isString(obj)) {
                api.ajax(obj, opt, param, function (res) {
                    api.renderOptions(opt, res, callback);
                });
            } else {
                api.renderOptions(opt, obj, callback);
            }
            
        },
        //渲染下拉数据
        renderOptions: function (opt, data, callback) {
            if (data.status === 'ok') {
                var $elem = layui.$('#' + opt['elem']);
                $elem.empty();
                if (data.count === 0) {
                    $elem.append("<option value=''>" + opt['empty'] + "</option>");
                } else {
                    //是否需要加载全部选项
                    if (opt['all']) {
                        $elem.append("<option value='0'>全部</option>");
                    } else {
                        $elem.append("<option value=''>" + opt['placeholder'] + "</option>");
                    }
                    //渲染数据
                    for (var i = 0; i < data.list.length; i++) {
                        if (opt['ext']) {
                            // 有扩展字段，则渲染扩展字段
                            $elem.append("<option value='" + data.list[i][opt['index']] + "' data-value='" + data.list[i][opt['ext']] + "'>" + data.list[i][opt['text']] + " - " + data.list[i][opt['ext']] + "</option>");
                        } else {
                            $elem.append("<option value='" + data.list[i][opt['index']] + "'>" + data.list[i][opt['text']] + "</option>");
                        }
                    }
                }
                layui.form.render();
            } else if (data.status === 'no') {
                api.warm(data.info);
            } else {
                api.error("网络请求错误");
            }
            api.isBack(callback, data);
        },
        // 加载信息
        loadInfo: function (url, param, callback) {
            param = lay.extend({}, param || {});
            api.ajax(url, {showResult: false}, param, function (res) {
                if (res.status === 'ok') {
                    //输入框
                    var $inputs = layui.$('input');
                    $inputs.each(function () {
                        if (this.type === "text") {
                            if (res.data[this.name]) {
                                layui.$(this).val(api.htmlDecode(res.data[this.name]));
                            } else {
                                layui.$(this).val("");
                            }
                        } else if (this.type === 'radio') {
                            // 单选按钮
                            //html 自带属性请用prop()方法,自定义属性用 attr() 方法
                            if (this.value === res.data[this.name].toString()) {
                                layui.$(this).prop("checked", true)
                            } else {
                                layui.$(this).removeProp("checked");
                            }
                        } else if (this.type === 'checkbox') {
                            // 复选框
                            var checkboxName = this.name.replace("[]", "");
                            if (checkboxName) {
                                //确认是复选框，而不是多选下拉
                                var checkboxValue = res.data[checkboxName];
                                var checkboxValues = (api.isString(checkboxValue)) ? checkboxValue.split(",") : checkboxValue.toString().split(",");
                                
                                // 判断当前值是否存在于数组中
                                if (checkboxValues.indexOf(this.value) !== -1) {
                                    layui.$(this).prop("checked", true)
                                } else {
                                    layui.$(this).removeProp("checked");
                                }
                            }
                        } else if (this.type === 'hidden') {
                            // 隐藏域
                            if (res.data[this.name] !== undefined) {
                                layui.$(this).val(api.htmlDecode(res.data[this.name]));
                            }
                        } else {
                            api.error("未知的表单类型:" + this.type);
                        }
                    })
                    
                    //下拉框
                    var $selects = layui.$('select');
                    $selects.each(function () {
                        //是否多选
                        if (this.multiple) {
                            // 选中的值
                            var checkboxValue = res.data[this.name];
                            console.log(checkboxValue);
                            if (checkboxValue !== undefined && checkboxValue !== 'null') {
                                var checkboxValues = (api.isString(checkboxValue)) ? checkboxValue.split(",") : checkboxValue.toString().split(",");
                                layui.$(this).val(checkboxValues);
                            }
                        } else {
                            // 单选下拉框
                            if (res.data[this.name] !== undefined) {
                                layui.$(this).val(api.htmlDecode(res.data[this.name]));
                            } else {
                                layui.$(this).val("");
                            }
                        }
                    })
                    
                    //富文本
                    var $extarea = layui.$('textarea');
                    $extarea.each(function () {
                        if (res.data[this.name] !== undefined) {
                            layui.$(this).val(res.data[this.name]);
                        }
                    })
                } else {
                    api.warm(res.info);
                }
                layui.form.render();
                api.isBack(callback, res);
            });
        },
        //加载详情
        loadDetail:function(obj,opt,param,callback){
            opt = opt || {};
            param = param || {};
            // 如果是网址，则请求数据
            if (api.isString(obj)) {
                api.ajax(obj, opt, param, function (res) {
                    if (res.status === 'ok') {
                        api.renderDetail(res.detail,res,callback);
                    } else if (res.status === 'no') {
                        api.warm(res.info);
                    } else {
                        api.error("网络请求错误");
                    }
                });
            }else{
                api.renderDetail(obj,obj,callback);
            }
        },
        //渲染详情
        renderDetail:function(detail,data,callback){
            $('[lay-detail]').each(function () {
                var field=$(this).data('field');
                if (field){
                    if (detail[field]) {
                        $Tags = $(this).prop('tagName');
                        if ($Tags == 'IMG') {
                            $("[data-field="+field+"]").attr('src', detail[field]);
                        } else if ($Tags == 'VIDEO') {
                            $("[data-field="+field+"]").attr('src', detail[field]);
                        } else {
                            $("[data-field="+field+"]").each(function (index,item) {
                                item.innerHTML = detail[field];
                            })
                        }
                    }
                }
            });
            api.isBack(callback, data);
        },
        // 添加数据
        dataAdd: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, opt || {});
            param = lay.extend({}, param || {});
            that.ajax(url, opt, param, function (res,option) {
                if (opt['refresh'] && opt['page']) {
                    parent.layui.admin.refresh(opt['page']);
                }
                that.isBack(callback, res,option);
            });
        },
        // 请求数据
        dataQuery: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, opt || {});
            param = lay.extend({}, param || {});
            that.ajax(url, opt, param, function (res,option) {
                that.isBack(callback, res,option);
            });
        },
        // 查看数据
        dataView: function (url, opt, callback) {
            opt = lay.extend({title: '查看详情', winWidth: '800px', winHeight: '500px'}, opt);
            
            // 判断宽度是否是像素格式的
            if (opt['winWidth'].indexOf('px') > -1) {
                // 将像素格式转为数字
                if (parseInt(opt['winWidth'].replace('px','')) > layui.$(window).width()) {
                    opt['winWidth'] = '95%';
                }
            }
            
            layer.open({
                type: 2,
                title: opt['title'],
                area: [opt['winWidth'], opt['winHeight']],
                content: url,
                end: function (layero) {
                    api.isBack(callback, layero);
                }
            });
        },
        // 提示后直接执行指令
        dataCheck: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, {title: '提示信息', icon: 0, btn: ['确定', '取消'], msg: '您确认需要这么操作吗?'}, opt || {});
            param = lay.extend({}, param || {});
            layer.confirm(opt['msg'], opt, function () {
                that.ajax(url, opt, param, function (res, option) {
                    console.log("check:",res,option);
                    that.isBack(callback, res, option);
                })
            });
        },
        // 修改数据
        dataEdit: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, {title: '修改数据', icon: 0, btn: ['确定', '取消'], msg: '你确定要修改该数据吗?'}, opt || {});
            param = lay.extend({}, param || {});
            layer.confirm(opt['msg'], opt, function () {
                that.ajax(url, opt, param, function (res,option) {
                    that.isBack(callback, res,option);
                })
            });
        },
        // 删除数据
        dataDelete: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, {title: '删除数据', icon: 3, btn: ['确定', '取消'], msg: '你确定要删除该数据吗？'}, opt || {});
            param = lay.extend({}, param || {});
            layer.confirm(opt['msg'], opt, function () {
                that.ajax(url, opt, param, function (res,option){
                    that.isBack(callback, res,option);
                })
            });
        },
        // 恢复数据
        dataRecovery: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, {title: '恢复数据', icon: 0, btn: ['确定', '取消'], msg: '你确定要恢复该数据吗？'}, opt || {});
            param = lay.extend({}, param || {});
            layer.confirm(opt['msg'], opt, function () {
                that.ajax(url, opt, param, function (res,option){
                    that.isBack(callback, res,option);
                })
            });
        },
        // 修改字段
        changeValue: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, {title: '修改字段', icon: 0, btn: ['确定', '取消'], msg: '你确定要修改该数据吗？'}, opt || {});
            param = lay.extend({}, param || {});
            layer.confirm(opt['msg'], opt, function () {
                that.ajax(url, opt, param, function (res,option){
                    that.isBack(callback, res,option);
                })
            });
        },
        // 二次确认
        dataVerify: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({}, {title: '提示信息', icon: 0, btn: ['确定', '取消'], msg: '你确定要执行该操作吗？'}, opt || {});
            param = lay.extend({}, param || {});
            layer.confirm(opt['msg'], opt, function () {
                that.ajax(url, opt, param, function (res,option) {
                    if (res.status === 'verify') {
                        param.verify = 'confirm';
                        opt.title = '二次确认';
                        opt.msg = res.info;
                        that.dataVerify(url, opt, param, callback);
                    } else {
                        that.isBack(callback, res,option);
                    }
                })
            });
        },
        // 输入确认
        dataPrompt: function (url, opt, param, callback) {
            var that = this;
            opt = lay.extend({},{title: '输入确认', icon: 0, btn: ['确定', '取消'], msg: '请输入内容', formType: 0,param:'remark'}, opt);
            layer.prompt(opt, function (value, index, elem) {
                param[opt['param']] = value;
                that.ajax(url, opt, param, function (res) {
                    layer.close(index);
                    that.isBack(callback, res);
                });
            });
        },
        /**
         * @title 模版数据
         * @param elem
         * @param data
         * @param opt
         * @param callback
         */
        dataTpl: function (elem, data, opt, callback) {
            var that = this;
            opt = $.extend({type: 'none'}, opt);
            var html = "";
            if (data) {
                //有数据的话
                layui.use('laytpl', function (laytpl) {
                    return laytpl($("#" + elem)[0].innerHTML).render(data, function (htmlRes) {
                        html = htmlRes;
                    });
                })
                
                // 直接渲染到页面上
                if (opt['type'] === 'none') {
                    $('$' + elem)[0].innerHTML = html;
                    that.isBack(callback, {});
                    return false;
                }
                
                // 仅返回html字符串
                if (opt['type'] === 'html') {
                    that.isBack(callback, {});
                    return html;
                }
                
                // 追加到页面上
                if (opt['type'] === 'append') {
                    $('$' + elem)[0].innerHTML += html;
                    that.isBack(callback, {});
                    return false;
                }
            }
        },
        // 查看图片
        previewImage: function (url, opt, callback) {
            opt =lay.extend({title: '查看图片', shade: 0.3,data:[{src:url}]}, opt);
            layui.layer.photos(opt);
        },
        // 查看视频
        viewVideo: function (url, opt, data, callback) {
            api.warm("暂不支持");
        },
        // 查看文件
        viewFile: function (url, opt, data, callback) {
            api.warm("暂不支持");
        },
        // 图片上传
        upload:function (btnElem,inputElem,opt,param,callback){
            var loading;
            opt = opt || {};
            param = param || {};
            opt = lay.extend({},{
                elem:btnElem,
                url: api.config.uploadImgUrl,
                multiple:false,
                unified:true,
                accept:'images',
                acceptMime:'image/*',
                field:'pic',
                data:param,
                before: function (obj) {
                    loading = layer.load("正在上传图片...", {shade: 0.2,icno:16,time:100000});
                },
                done: function (res) {
                    if (api.isFunction(callback)){
                        // 有回调
                            layui.layer.close(loading);
                            // 多选的回调在allDone里
                            layui.$(inputElem).val(res.src);
                            callback(res);
                    }else{
                        // 没有回调
                        layui.layer.close(loading);
                        if (res.status === 'ok'){
                                layui.$(inputElem).val(res.src);
                        }else{
                            layer.msg('上传失败:' + res.info, { icon: 2, shade: 0.2, time: 5000 });
                        }
                    }
                },
                error: function (res) {
                    layui.layer.close(loading);
                    layui.layer.msg('上传失败', { icon: 2, shade: 0.2, time: 3000 });
                }
            },opt);
            layui.use('upload', function (upload) {
                upload.render(opt);
            });
        },
        // 图片上传
        uploadImage:function (btnElem,inputElem,opt,param,callback) {
            opt = lay.extend({},{accept:'images',acceptMime:'image/*',field:'pic'}, opt || {});
            param = param || {};
            api.upload(btnElem,inputElem,opt,param,callback);
        },
        // 文件上传
        uploadFile:function (btnElem,inputElem,opt,param,callback) {
            opt = lay.extend({},{accept:'file',acceptMime:'file/*',field:'file'}, opt || {});
            param = param || {};
            api.upload(btnElem,inputElem,opt,param,callback);
        },
        // 表格功能
        dataTable: function (url,opt,param, callback) {
            // 构建参数
            param = lay.extend({}, param || {});
            // 初始化参数
            var option = lay.extend({},{
                elem: '#dataTable',
                url: url,
                method: 'POST',
                where: param,
                request: {pageName: 'pageNo', limitName: 'pageSize'},
                response: {dataName: 'list'},
                toolbar: false,
                defaultToolbar: false,
                height: 500,
                totalRow: false,
                page: {theme: '#318bd7'},
                limit: 10,
                limits: [10, 20, 30, 50, 100, 500, 1000],
                loading: true,
                scrollPos: 'reset',  //用于设置重载数据或切换分页时的滚动条位置状态，可选值：fixed（保持不变）/reset（重置到初始状态）/default（默认状态）
                autoSort: false,     //是否由组件自动进行前端排序。若为 false，则需自主排序
                title: '数据列表',
                editTrigger: 'click',    //是用于设定单元格编辑的事件触发方式。如双击: dblclick,单击: click
                cellExpandedMode:'tips',    //用于设置所有单元格默认展开方式，可选值有：
                done: function (res, curr, count, origin) {
                    api.isBack(callback, {res: res, curr: curr, count: count, origin: origin});
                }
            },opt);
            table.render(option);
        },
        // 表格导出
        dataTableExport: function (url, opt, param, callback) {
            var that = this;
            $.extend({export: true, title: '您确定要按本条件进行导出数据吗？', loadingText: '正在导出...', loadingTime: 0}, opt);
            layer.confirm(opt['title'], {icon: 3, title: '提示', btn: ['确定', '取消']}, function () {
                api.ajax(url, opt, param, function (res) {
                    if (res.status === 'ok') {
                        if (Reflect.has(opt, 'download')) {
                            layer.open({
                                content: res.info
                                , icon: 1
                                , btn: ['确定', '取消']
                                , yes: function (layero) {
                                    layer.close(layero);
                                    window.open(res.download);
                                }
                            })
                        }
                    } else {
                        that.isBack(callback, res);
                    }
                })
            });
        },
        // 日期选择
        renderDate: function (elem, opt, callback) {
            var that = this;
            if (elem) opt['elem']=elem;
            opt = lay.extend({},{elem:'.layui-api-date',type: 'date', format: 'yyyy-MM-dd', max: '2099-12-31', range: '至',rangeLinked: true, search: true}, opt);
            opt['done'] = function (value, date, endDate, id) {
                if (opt['search']) {
                    // 搜索功能
                    var param = {};
                    param[id] = value;
                    api.search({where: param})
                }
                that.isBack(callback, {value: value, startDate: date, endDate: endDate, id: id});
            }
            layui.use('laydate', function (laydate) {
                laydate.render(opt)
            })
        },
        // HTML编码
        htmlEncode: function (html) {
            var temp = document.createElement("div");
            (temp.textContent !== undefined) ? (temp.textContent = html) : (temp.innerText = html);
            return temp.innerHTML;
        },
        // HTML解码
        htmlDecode: function (str) {
            var temp = document.createElement("div");
            temp.innerHTML = str;
            return temp.innerText || temp.textContent;
        }
    }
    
    exports('api', api);
});
